/**
 * Shared invalidation after a confirmed give/take (mutation success or credit stream).
 */
import type { QueryClient } from '@tanstack/react-query'
import { keys } from '@/api/hooks/shared/keys'

export function invalidateAfterCreditTransfer(client: QueryClient): void {
  client.invalidateQueries({ queryKey: keys.session })
  client.invalidateQueries({ queryKey: ['account'] })
  client.invalidateQueries({ queryKey: ['downline'] })
  client.invalidateQueries({ queryKey: ['children'] })
  client.invalidateQueries({ queryKey: ['overview'] })
  client.invalidateQueries({ queryKey: ['transfers'] })
  client.invalidateQueries({ queryKey: ['statement'] })
  client.invalidateQueries({ queryKey: ['member-detail'] })
  client.invalidateQueries({ queryKey: keys.createParent })
}
